import React, { FC, useEffect, useState } from 'react';
import { isBloggerBusiness } from '../../../utils/accessService';
import { useTranslation } from '../../../utils/useTranslation';
import { IconForward } from '../../icon/IconForward';
import { Flex } from '../../layout/Flex';
import { Avatar } from '../../media/Avatar';
import { Typography } from '../../typography/Typography';
import { PostBusinessInfoProps } from './types';

export const PostBusinessInfo: FC<PostBusinessInfoProps> = ({
    business,
    businessButtonTitle,
    onBusinessClick,
    trackButtonShown,
    ...other
}) => {
    const t = useTranslation();
    const [hasShownLogged, setHasShownLogged] = useState(false);
    const enabled = business?.siteUrl && !isBloggerBusiness(business.type);

    useEffect(() => {
        if (enabled && business?.siteUrl && !hasShownLogged) {
            setHasShownLogged(true);
            trackButtonShown?.('GoToSite', business.siteUrl);
        }
    }, [business, enabled, hasShownLogged, trackButtonShown]);

    if (!enabled) {
        return null;
    }

    return (
        <Flex
            as="a"
            target="_blank"
            direction="row"
            justifyContent="space-between"
            width="100%"
            alignItems="center"
            textDecoration="none"
            href={business.siteUrl}
            py={1.5}
            onClick={() => onBusinessClick(business.siteUrl!)}
            {...other}
        >
            <Flex direction="row" alignItems="center" spacing={2}>
                <Avatar
                    width={34}
                    title={business.displayName}
                    src={business.avatarUrl}
                    border="1px solid var(--divider)"
                />
                <Flex>
                    <Typography>{businessButtonTitle || t('Еще товары')}</Typography>
                    <Typography variant="caption" color="secondary">
                        {business.shortSite}
                    </Typography>
                </Flex>
            </Flex>
            <IconForward fontSize="16px" fill="var(--color-primary)" />
        </Flex>
    );
};
